export const sw: Record<string, string> = {
  // Nav & System Drawer
  'nav.dashboard': 'Dashibodi',
  'nav.focus': 'Malengo ya Kila Siku & Ramani',
  'nav.ai_assistant': 'Injini ya Uendeshaji ya Kiotomatiki',
  'nav.calendar': 'Kalenda ya Google',
  'nav.book': 'Ukurasa wa Uhifadhi wa Umma',
  'nav.bookings': 'Nafasi za Wateja & Mapato',
  'nav.invoices': 'Ankara (Invoices)',
  'nav.expenses': 'Gharama za Biashara',
  'nav.settings': 'Makao Makuu ya Kodi & Biashara',
  'nav.billing': 'Usajili na Vifurushi',
  'nav.j_lens': 'Hifadhi ya J-Lens',
  'nav.concept': 'Dhana & Falsafa',
  'nav.what_is': 'AzuraOS ni nini?',
  'nav.export': 'Pakua & Hifadhi Nakala',
  'nav.menu': 'Menyu',
  'nav.welcome': 'Karibu & Kituo cha BYOK',
  'nav.app_stack_modules': 'Moduli za Mfumo',
  'nav.core_engines': 'Injini 8 Kuu',
  'nav.manifesto': 'Mfumo & Ilani ya Waanzilishi',
  'nav.workspace_actions': 'Vitendo vya Eneo la Kazi',
  'nav.export_records': 'Hamisha Kumbukumbu',
  'nav.load_demo': 'Pakia Data ya Majaribio',
  'nav.partnerships': 'Ushirikiano & Usaidizi',
  'nav.request_partnership': 'Omba Ushirikiano wa Kibiashara',
  'nav.partner_subtext': 'Muunganisho wa benki, vikundi na ufadhili',
  'nav.interface_language': 'Lugha ya Mfumo',
  'nav.legal_trust': 'Kisheria & Uaminifu',
  'nav.security': 'Usalama',
  'nav.faqs': 'Maswali ya Mara kwa Mara',
  'nav.terms': 'Vigezo na Masharti',
  'nav.privacy': 'Sera ya Faragha',
  'nav.refund': 'Sera ya Kurejeshewa Fedha',
  'nav.contact': 'Wasiliana Nasi',
  'nav.report_bug': 'Ripoti Hitilafu',
  'nav.invite_founder': '+ Alika Mwanzilishi',
  'nav.privacy_active': 'Hali ya Faragha: IMEWASHWA',
  'nav.privacy_off': 'Hali ya Faragha: IMEZIMWA',
  'nav.masked': 'Imefichwa',
  'nav.visible': 'Inaonekana',
  'nav.live_margin': 'FAIDA HALISI YA UENDESHAJI',
  'nav.target_safe_zone': 'Lengo la Usalama:',
  'nav.close_menu': 'Funga Menyu',
  'nav.founder_access': 'Ingia / Ufikiaji wa Mwanzilishi',
  'nav.private_vault': 'Hifadhi ya Kibinafsi Imeunganishwa',
  'nav.master_access': 'Ufikiaji Mkuu wa Mwanzilishi',
  'nav.lifetime': 'Maisha Yote',
  'nav.pro_active': 'Sovereign Pro Imewashwa',
  'nav.trial_days': 'Majaribio ya Siku 7: Zimebaki siku {days}',
  'nav.trial_expired': 'Muda wa Majaribio Umekwisha',
  'nav.manage': 'Dhibiti →',
  'nav.upgrade': 'Boresha Kifurushi →',
  'nav.unlock_pro': 'Fungua Pro →',

  // Dashboard Cards & Sections
  'dash.greeting_morning': 'Habari ya asubuhi',
  'dash.greeting_afternoon': 'Habari ya mchana',
  'dash.greeting_evening': 'Habari ya jioni',
  'dash.value_prop': 'Udhibiti wa vyanzo vingi vya mapato sehemu moja: Weka chanzo 1 cha mapato na gharama 1 kuona faida yako halisi mubashara.',
  'dash.manage_streams': 'Dhibiti Vyanzo vya Mapato',
  'dash.close_streams': 'Funga Vyanzo',
  'dash.income': 'Mapato Jumla',
  'dash.collected': 'Yaliyopokelewa',
  'dash.unpaid': 'Yasiyolipwa',
  'dash.expenses': 'Gharama za Biashara',
  'dash.across_records': 'Kwenye kumbukumbu zote',
  'dash.net_profit': 'Faida Halisi (Net Profit)',
  'dash.daily_focus_title': 'Mpango Kazi wa Mapato wa Kila Siku',
  'dash.daily_focus_sub': 'Kazi zenye thamani kubwa zinazoleta faida na ukuaji wa biashara',
  'dash.open_focus': 'Fungua Ramani ya Kazi',
  'dash.stream_profitability': 'Faida ya Kila Chanzo',
  'dash.stream_sub': 'Huduma 1 au vyanzo vingi • Ufuatiliaji wa faida mubashara',
  'dash.quick_actions': 'Vitendo vya Haraka',
  'dash.add_booking': 'Ongeza Mteja / Nafasi',
  'dash.add_booking_desc': 'Sajili chanzo kipya cha mapato ya mteja',
  'dash.add_expense': 'Weka Gharama',
  'dash.add_expense_desc': 'Rekodi gharama za uendeshaji wa biashara',
  'dash.add_insight': 'Ongeza Ushauri / Maarifa',
  'dash.add_insight_desc': 'Hifadhi kanuni mpya ya J-Lens',
  'dash.quick_add_title': 'Ingizo la Haraka',
  'dash.quick_revenue': '+ MAPATO YA HARAKA (MTEJA)',
  'dash.quick_expense': '+ GHARAMA YA HARAKA (LEJA)',
  'dash.recent_activity': 'Shughuli za Hivi Karibuni',
  'dash.no_activity': 'Hakuna shughuli iliyorekodiwa bado. Tumia vitendo vya haraka hapo juu kuanza.',
  'dash.spotlight_insight': 'Ushauri Bora wa J-Lens',
  'dash.access_vault': 'Fungua Hifadhi →',
  'dash.sandbox_active': 'Hali ya Majaribio Imewashwa',
  'dash.load_demo_data': 'Pakia Data ya Majaribio',
  'dash.clear_sandbox': 'Futa Data ya Majaribio',
  'dash.clear_confirm': 'Je, una uhakika wa kufuta data?',
  'dash.yes_clear': 'Ndio, futa',
  'dash.cancel': 'Ghairi',

  // Bookings View
  'bookings.title': '📅 Nafasi za Wateja & Mapato',
  'bookings.subtitle': 'Mifereji ya mapato ya wateja huru',
  'bookings.public_page': 'Ukurasa wa Uhifadhi wa Umma',
  'bookings.import_csv': 'Ingiza Faili ya CSV',
  'bookings.add_button': 'Ongeza Mteja',
  'bookings.client_link_title': 'Kiungo cha Kujihudumia cha Mteja',
  'bookings.client_link_desc': 'Shiriki viungo vya kawaida au bei maalum kwa wateja kujiwekea nafasi na kuunganisha na Kalenda ya Google.',
  'bookings.link_active': 'Inafanya Kazi',
  'bookings.generate_custom_link': '⚡ Tengeneza Kiungo cha Bei Maalum',
  'bookings.hide_custom_link': 'Ficha Kiungo cha Bei',
  'bookings.copy_standard_link': 'Nakili Kiungo cha Kawaida',
  'bookings.copied_link': 'Kiungo kimenakiliwa!',
  'bookings.preview': 'Tazama',
  'bookings.search_placeholder': 'Tafuta kwa jina la mteja au huduma...',
  'bookings.filter_all': 'Vyanzo Vyote',
  'bookings.table_client': 'Jina la Mteja',
  'bookings.table_stream': 'Huduma / Chanzo',
  'bookings.table_date': 'Tarehe',
  'bookings.table_amount': 'Kiasi',
  'bookings.table_status': 'Hali',
  'bookings.table_actions': 'Vitendo',
  'bookings.mark_paid': 'Weka Imelipwa',
  'bookings.mark_unpaid': 'Weka Haijalipwa',
  'bookings.delete': 'Futa',
  'bookings.no_records': 'Hakuna nafasi za wateja zilizopatikana. Tumia "Ongeza Mteja" kuanza.',

  // Invoices View
  'invoices.title': '📄 Ankara za Wateja na Malipo',
  'invoices.subtitle': 'Utoaji wa ankara za kitaalamu na ufuatiliaji wa malipo',
  'invoices.create_invoice': 'Tengeneza Ankara Mpya',
  'invoices.tab_all': 'Ankara Zote',
  'invoices.tab_paid': 'Zilizolipwa',
  'invoices.tab_outstanding': 'Zinazosubiri Malipo',
  'invoices.tab_overdue': 'Zilizopitisha Muda',
  'invoices.table_number': 'Nambari ya Ankara',
  'invoices.table_client': 'Mteja',
  'invoices.table_issue_date': 'Tarehe ya Kutolewa',
  'invoices.table_due_date': 'Tarehe ya Mwisho',
  'invoices.table_total': 'Jumla ya Kiasi',
  'invoices.table_status': 'Hali',
  'invoices.download_pdf': 'Pakua PDF',
  'invoices.mark_as_paid': 'Weka Imelipwa',
  'invoices.no_records': 'Hakuna ankara zilizotengenezwa bado. Tengeneza ankara kuanza kufuatilia malipo.',

  // Expenses View
  'expenses.title': '💳 Gharama za Biashara & Leja',
  'expenses.subtitle': 'Ufuatiliaji wa matumizi na upunguzaji wa kodi unaoruhusiwa kisheria',
  'expenses.log_expense': 'Weka Gharama',
  'expenses.import_csv': 'Ingiza CSV',
  'expenses.total_outflow': 'Jumla ya Gharama Zote',
  'expenses.tax_deductible': 'Inayokatwa Kwenye Kodi',
  'expenses.search_placeholder': 'Tafuta kwa jina la muuzaji au maelezo...',
  'expenses.filter_all': 'Makundi Yote',
  'expenses.table_category': 'Kundi',
  'expenses.table_description': 'Maelezo / Muuzaji',
  'expenses.table_date': 'Tarehe',
  'expenses.table_claimable': 'Inadaiwa Kodi',
  'expenses.table_amount': 'Kiasi',
  'expenses.table_actions': 'Vitendo',
  'expenses.claimable_yes': 'Ndio (Inapunguza Kodi)',
  'expenses.claimable_no': 'Hapana (Binafsi)',
  'expenses.no_records': 'Hakuna gharama zilizorekodiwa bado. Weka gharama kuhesabu faida halisi.',

  // Daily Focus & Roadmap
  'focus.title': '🎯 Malengo ya Kila Siku & Mpango wa Mapato',
  'focus.subtitle': 'Kazi zenye matokeo makubwa kwa mzunguko wa fedha na faida',
  'focus.add_task': 'Ongeza Kazi ya Mapato',
  'focus.active_tasks': 'Kazi Muhimu Zinazoendelea',
  'focus.completed_tasks': 'Kazi Zilizokamilika',
  'focus.high_leverage': 'Kipaumbele cha Juu',
  'focus.mark_done': 'Kamilisha',
  'focus.delete_task': 'Futa',
  'focus.no_tasks': 'Kila kitu kimekamilika! Ongeza kazi mpya kuendeleza mafanikio.',

  // Automated Operational Engine
  'ai.title': '⚡ Injini ya Uendeshaji ya Kiotomatiki',
  'ai.subtitle': 'Hesabu zilizolindwa upande wa kivinjari na ushauri wa uendeshaji (Bila kuhifadhi data ya siri)',
  'ai.ask_placeholder': 'Uliza kuhusu mzunguko wa fedha, faida au mikakati ya bei...',
  'ai.send': 'Chambua',
  'ai.thinking': 'Injini ya uendeshaji inachakata hesabu zako za fedha...',
  'ai.prompt_margin': 'Nawezaje kuongeza faida yangu halisi hadi 60%?',
  'ai.prompt_tax': 'Ni gharama gani ninazopaswa kuweka ili kupunguza mzigo wa kodi?',
  'ai.prompt_pricing': 'Je, nipangaje bei za vifurushi vya ushauri wa kila mwezi?',
  'ai.clear_chat': 'Futa Mazungumzo',

  // Business & Tax HQ
  'hq.title': '🏢 Makao Makuu ya Kodi & Biashara',
  'hq.subtitle': 'Wasifu, sarafu, sheria za kodi ya VAT, mipangilio ya nchi na ripoti za uhasibu',
  'hq.tab_profile': 'Wasifu & Utambulisho',
  'hq.tab_currency_tax': 'Sarafu & Sheria za Kodi',
  'hq.tab_accountant_view': 'Mtazamo wa Mhasibu & Mkaguzi (CPA)',
  'hq.tab_exports': 'Pakua & Hifadhi Nakala',
  'hq.tab_security': 'Usalama & Ulinzi',
  'hq.jurisdiction_preset_title': 'Mipangilio ya Nchi ya Eneo Lako',
  'hq.jurisdiction_preset_desc': 'Chagua nchi yako ili kuweka sarafu kiotomatiki, kiwango cha VAT/Kodi na mamlaka rasmi ya mapato.',
  'hq.accountant_view_title': 'Mtazamo wa Mhasibu & Mkaguzi (CPA)',
  'hq.accountant_view_desc': 'Muhtasari wa kina wa mahesabu ya awali uliotayarishwa kwa mhasibu wa nje au ukaguzi wa benki.',
  'hq.export_pdf_audit': 'Ripoti ya Ukaguzi ya PDF Inayoweza Kuchapishwa',
  'hq.export_csv_audit': 'Pakua Faili ya Ukaguzi ya CSV',
  'hq.currency_symbol': 'Alama ya Sarafu',
  'hq.currency_code': 'Kodi ya Sarafu',
  'hq.vat_rate': 'Kiwango cha VAT / Kodi (%)',
  'hq.tax_authority': 'Jina la Mamlaka ya Mapato',
  'hq.save_settings': 'Hifadhi Mipangilio ya Biashara',

  // Financial & Metric Labels
  'metric.gross_revenue': 'Mapato Jumla',
  'metric.total_expenses': 'Gharama Zote',
  'metric.net_profit': 'Faida Halisi ya Uendeshaji',
  'metric.profit_margin': 'Kiwango cha Faida Halisi',
  'metric.active_bookings': 'Wateja Walio Wazi',
  'metric.paid_invoices': 'Ankara Zilizolipwa',
  'metric.unpaid_invoices': 'Ankara Zinazosubiri Malipo',
  'metric.tax_buffer': 'Kiwango cha Akiba ya Kodi',
  'metric.currency': 'Sarafu ya Uendeshaji',
  'metric.tax_rate': 'Kiwango cha VAT / Kodi',

  // Actions & Common Buttons
  'btn.save': 'Hifadhi Mabadiliko',
  'btn.cancel': 'Ghairi',
  'btn.download': 'Pakua',
  'btn.export_pdf': 'Pakua Ripoti kama PDF',
  'btn.export_csv': 'Pakua kama CSV',
  'btn.cpa_pack': 'Pakua Nyaraka za Mhasibu',
  'btn.new_booking': 'Sajili Mteja',
  'btn.new_expense': 'Sajili Gharama',
  'btn.add_task': 'Ongeza Kazi',
  'btn.sync_calendar': 'Unganisha Kalenda ya Google',
  'btn.privacy_mode': 'Hali ya Faragha',
  'btn.manage_subscription': 'Dhibiti Usajili',
  'btn.sign_in': 'Ingia / Ufikiaji',
  'btn.sign_out': 'Ondoka',
  'btn.delete': 'Futa',
  'btn.edit': 'Hariri',
  'btn.close': 'Funga',

  // Statuses
  'status.paid': 'Imelipwa',
  'status.unpaid': 'Haijalipwa',
  'status.overdue': 'Imepitisha Muda',
  'status.safe': 'Faida Nzuri',
  'status.warning': 'Tahadhari ya Faida',
  'status.trial_active': 'Majaribio ya Bure Yanafanya Kazi',
  'status.pro_active': 'Sovereign Pro',
};
